var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 border pa-20 pa-md-30 d-flex flex-column justify-center icon-box"
  }, [_c('div', {
    staticClass: "d-flex d-lg-block justify-end"
  }, [_c('v-img', {
    staticClass: "icon-box-icon mb-6 mb-lg-0",
    attrs: {
      "src": _vm.icon,
      "max-width": _vm.iconWidth
    }
  })], 1), _c('p', {
    staticClass: "font-weight-bold color-point font-size-16 font-size-lg-20 mb-2 mb-lg-48"
  }, [_vm._v(" " + _vm._s(_vm.num) + " ")]), _c('p', {
    staticClass: "color-grey-2c font-size-14 font-size-lg-16"
  }, [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }